// extracted by mini-css-extract-plugin
export default {"title":"VerifiedCard_title__8xkoy","haveAcc":"VerifiedCard_haveAcc__0l+Xb","login":"VerifiedCard_login__Mfqt5"};